import { gql } from '@apollo/client';
import Fragments from './fragments';
import CommonFragments from 'features/common/fragments';

export const FINANCIAL_PRODUCT_UPDATED = gql`
  subscription financialProductUpdated {
    financialProductUpdated {
      financialProduct {
        ...financialProductItem
        leasingFinancialProduct {
          ...leasingFinancialProductItem
        }
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${Fragments.financialProductItem}
  ${Fragments.leasingFinancialProductItem}
  ${CommonFragments.messageHeaders}
`;

export const FINANCIAL_PRODUCT_STATE_UPDATED = gql`
  subscription financialProductStateUpdated {
    financialProductStateUpdated {
      headers {
        ...messageHeaders
      }
      stateId
      productId
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const FINANCIAL_PRODUCT_RULE_REMOVED = gql`
  subscription financialProductRuleDeleted {
    financialProductRuleDeleted {
      ruleId
    }
  }
`;

export const FINANCIAL_PRODUCT_WARRANTY_REMOVED = gql`
  subscription financialProductWarrantyDeleted {
    financialProductWarrantyDeleted {
      leasingFinancialProductXWarrantyId
    }
  }
`;
export const FINANCIAL_PRODUCT_INSURER_DELETED = gql`
  subscription financialProductInsurerDeleted {
    financialProductInsurerDeleted {
      leasingFinancialProductXLeasInsurerId
    }
  }
`;

export const FINANCIAL_PRODUCT_INSURER_UPDATED = gql`
  subscription financialProductInsurerUpdated {
    financialProductInsurerUpdated {
      outputData {
        ...financialProductInsurer
      }
      headers {
        ...messageHeaders
      }
    } 
}
${CommonFragments.messageHeaders}
${Fragments.financialProductInsurer}
`;

export const FINANCIAL_PRODUCT_PROPERTY_DELETED = gql`
  subscription financialProductPropertyDeleted {
    financialProductPropertyDeleted {
      leasingFinancialProductPropertyId
    }
  }
`;

export const FINANCIAL_PRODUCT_PROPERTY_UPDATED = gql`
  subscription  {
    financialProductPropertyUpdated {
      leasingFinancialProductPropertyId
      productId
      propertyId
    }
  }
`;

export const FINANCIAL_PRODUCT_RESIDUAL_GRID_DELETED = gql`
  subscription financialProductResidualGridDeleted {
    financialProductResidualGridDeleted {
      financialProductXResidualValueGridId
    }
  }
`;

export const FINANCIAL_PRODUCT_RESIDUAL_GRID_UPDATED = gql`
  subscription  {
    financialProductResidualGridUpdated {
      financialProductXResidualValueGridId
      productId
      gridId
      gridName
      maximumIncrease
      maximumDecrease
    }
  }
`;